import { Button } from "@/components/ui/button";

export function errorStep(error: unknown, fields: readonly (readonly string[])[]): number | undefined {
  if (!(error instanceof Error)) return undefined;
  const message = error.message.toLowerCase();
  const step = fields.findIndex((group) => group.some((field) => new RegExp(`\\b${field}\\b`).test(message)));
  return step < 0 ? undefined : step;
}

/** Sequential navigation keeps validation with the page that owns each field. */
export function FormStepNavigation({ steps, step, onBack, onNext, nextDisabled = false, busy = false }: {
  steps: readonly string[];
  step: number;
  onBack: () => void;
  onNext: () => void;
  nextDisabled?: boolean;
  busy?: boolean;
}): JSX.Element {
  return <div className="space-y-3">
    <nav aria-label="Form progress">
      <p aria-current="step" aria-live="polite" className="text-sm font-medium">
        Step {step + 1} of {steps.length}: {steps[step]}
      </p>
    </nav>
    <div className="flex flex-wrap gap-2">
      <Button type="button" variant="outline" disabled={step === 0 || busy} onClick={onBack}>Back</Button>
      {step < steps.length - 1 ? <Button type="button" disabled={nextDisabled || busy} onClick={onNext}>Next</Button> : null}
    </div>
  </div>;
}
